import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Loader from '../Loader';
import * as XLSX from "xlsx";
import { toast } from 'sonner'

const Reversed = () => {

  const [reversedRequests, setReversedRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)
  const [serviceType, setServiceType] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedRequestId, setSelectedRequestId] = useState('');
  const [amount, setAmount] = useState('')
  const [account_no, setAccount_no] = useState('')

  // Fetch Reversed reports
  const getFailedReports = useCallback(async (offset, limit, msisdn) => {
    try {
      let query = `?offset=${offset}&limit=${limit}&status_id=5`

      if (serviceType) {
        query += `&service_type=${serviceType}`
      }

      if (startDate) {
        query += `&start_date=${startDate}`
      }

      if (endDate) {
        query += `&end_date=${endDate}`
      }

      if (msisdn) {
        query += `&msisdn=${msisdn}`
      }

      const response = await axios.get(`/requests/log-failed${query}`);
      setReversedRequests(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError('Network error! Check your connection.');
      } else if (error.response.status >= 500) {
        setError('Server error! Please try again later.');
      } else {
        setError('An unexpected error occurred!');
      }
    }
  }, [serviceType, endDate, startDate]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLoading(true);
      getFailedReports((currentPage - 1) * recordsPerPage, recordsPerPage);
    }, 1000);
    return () => clearTimeout(timerId);
  }, [currentPage, recordsPerPage, getFailedReports]);


  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
    const excelData = reversedRequests.map((row) => {
      return {
        "ID": row.id,
        "MSISDN": row.msisdn,
        "Amount": row.amount,
        "Provider": row.provider,
        "Narration": row.Narration,
        "Transaction Date": new Date(row.trans_date).toISOString().replace('T', ' ').slice(0, 19),
        "Created Date": new Date(row.date_created).toISOString().replace('T', ' ').slice(0, 19), 
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reversed Requests");
    XLSX.writeFile(workbook, "reversed_requests.xlsx");
  };

  const openModal = (id) => {
    setSelectedRequestId(id);
    const dialog = document.getElementById('my_modal_3');
    if (dialog !== null) {
      dialog.showModal();
    }
  };

  // getting transaction by id
  const id = selectedRequestId
  useEffect(() => {
    const fetchPending = async() => {
      const response = await axios.get(`/request_log_failed/${id}`)
      setAmount(response.data.amount)
      setAccount_no(response.data.account_no)
    }
    fetchPending()
  },[id])

  // requeue failed Transaction 
  const handleSubmit = async (e) => {
    e.preventDefault()
    const confirmed = window.confirm('Are you sure you want to retry this transaction');
    if (confirmed) {
      try {
        await axios.put(`/request_log_failed/resend/${id}`, { account_no })
        toast.success('Transaction Requed');
        getFailedReports((currentPage - 1) * recordsPerPage, recordsPerPage);
      } catch (error) {
        if (!error?.response) {
          toast.error('No Server Response');
        } else if (error.response?.status === 400 || 404) {
          toast.error(error.response.data.detail);
        } else {
          toast.error('Reversed to upload file!!');
        }
        console.log(error);
      }
    }
  }


  return (
    <div className='mx-auto p-4'>
      <h4 className="my-2"><b>Reversed Requests</b></h4>
      <div className='bg-white rounded-lg p-4 xl:w-[78vw] 2xl:w-full'>
        <div className="flex items-center justify-between py-2">
          <div className='flex space-x-3 items-center'>
            
            <div>
              <span className='mr-2'>Service Type:</span>
              <select
                className='px-3 py-1 border bg-[#f2f9ff] border-slate-300 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e]'
                value={serviceType}
                onChange={(e) => {setServiceType(e.target.value)}}
              >
                <option value=''>Service Type</option>
                <option value='2'>Airtime</option>
                <option value='5'>Bundle</option>
              </select>
            </div>
          </div>
          <div>
            <span className='font-bold text-[#2b1e3e]'>{count} / {total.toLocaleString() || 0} records</span>
          </div>
          <div className='flex space-x-2'>
            <button className='bg-[#134463] text-white px-4 py-1 rounded-lg hover:bg-[#2b1e3e]' onClick={handleExport}>Export</button>
            <form className='flex space-x-3 items-center'>
              <label htmlFor="">
                <span className='hidden'>Start Date</span>
                <input 
                  type="date"
                  className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
                  value={startDate}
                  onChange={(e) => {setStartDate(e.target.value)}}
                />
              </label>
              <label htmlFor="">
                <span className='hidden'>End Date</span>
                <input 
                  type="date" 
                  className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
                  value={endDate}
                  onChange={(e) => {setEndDate(e.target.value)}}
                />
              </label>
            </form>
          </div>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#eef1ff] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#eef1ff] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {reversedRequests.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>No</th>
                      <th className='p-2'>Phone Number</th>
                      <th className='p-2'>Account Number</th>
                      <th className='p-2'>Amount</th>
                      <th className='p-2'>Provider</th>
                      <th className='p-2'>Narration</th>
                      <th className='p-2'>Response</th>
                      <th className='p-2'>Transaction Date</th>
                      <th className='p-2'>Created At</th>
                      <th className='p-2'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reversedRequests.map((request) => (
                      <tr key={request.id}>
                        <td className='p-2 '>{request.id}</td>
                        <td className='p-2'>{request.msisdn}</td>
                        <td className='p-2'>{request.account_no}</td>
                        <td className='p-2'>{request.amount}</td>
                        <td className='p-2'>{request.provider}</td>
                        <td className='p-2'>{request.narration}</td>
                        <td className='p-2'>{request.response}</td>
                        <td className='p-2'>{new Date(request.tran_date).toISOString().replace('T', ' ').slice(0, 19)}</td>
                        <td className='p-2'>{new Date(request.date_created).toISOString().replace('T', ' ').slice(0, 19)}</td>
                        <td className='p-2'>
                          <button
                            onClick={() => {openModal(request.id)}}
                            className='bg-[#134463] text-white px-4 hover:bg-[#2b1e3e] rounded-full'
                          >
                            Resend
                          </button>
                          <dialog id="my_modal_3" className="modal">
                            <div className="modal-box">
                              <form method="dialog">
                                {/* if there is a button in form, it will close the modal */}
                                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                              </form>
                              <form onSubmit={handleSubmit}>
                                <div className='mt-2'>
                                  <label htmlFor=""><span>Amount</span>
                                  <input 
                                    type="number"
                                    placeholder="Amount"
                                    className='px-3 py-2 bg-white border border-slate-300 disabled:bg-neutral-100 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 w-full rounded-md focus:ring-1'
                                    value={amount}
                                    disabled
                                    onChange={(e) => {setAmount(e.target.value)}}
                                  />
                                  </label>
                                </div>
                                <div className='mt-2'>
                                  <label htmlFor=""><span>Phone Number</span>
                                  <input 
                                    type="number"
                                    placeholder="Phone Number"
                                    className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 w-full rounded-md focus:ring-1'
                                    value={account_no}
                                    onChange={(e) => {setAccount_no(e.target.value)}}
                                  />
                                  </label>
                                </div>
                                <div className='mt-3'>
                                  <button className='bg-blue-600 text-white px-4 py-0.5 hover:bg-blue-500 rounded-full'>Resend</button>
                                </div>
                              </form>
                            </div>
                          </dialog>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#eef1ff] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#eef1ff] border-slate-300 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Reversed;
